import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import RenewalSuggestionRenderer from './RenewalSuggestionRenderer';
import './GroupedRenewalSuggestionsList.less';

const GroupedRenewalSuggestionsList: React.FC = () => {
    const { renewalSuggestionsStore } = useAppStore();

    return (
        <div className="grouped-renewal-suggestions-list-container">
            {Object.entries(renewalSuggestionsStore.state.groupedSuggestions).map(([layerId, suggestions]) => {
                if (!suggestions.length) {
                    return null;
                }

                return (
                    <div key={layerId} className="group-container">
                        <span className="group-title">{layerId.replace(':', ' ')}</span>

                        <div className="group-cards-container">
                            {suggestions.map((suggestion, index) => (
                                <RenewalSuggestionRenderer
                                    key={`${suggestion.businessId}-${index}`}
                                    suggestionsKey={layerId}
                                    suggestion={suggestion}
                                />
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default observer(GroupedRenewalSuggestionsList);
